import React from 'react';
import AccountDetailsCard from '../../Account/AccountDetailsCard';

export default function AccountProfilePage() {
	return (
		<div>
			<AccountDetailsCard />
		</div>
	);
}
